"use client";

import { Clock3 } from "lucide-react";
import { MaskedHeadline, Reveal } from "./motion-primitives";

const STEPS = [
  {
    title: "Tell Us What You Need",
    copy: "Share the occasion, audience, quantity, and general idea.",
  },
  {
    title: "Send Your Artwork or Inspiration",
    copy: "Upload any logo, artwork, reference image, or notes you already have.",
  },
  {
    title: "Receive Recommendations and Pricing",
    copy: "Mills Engraving will review the request and discuss the available options.",
  },
  {
    title: "Approve Your Quote",
    copy: "Once the details are confirmed, the project can move into production.",
  },
];

export function Process() {
  return (
    <section className="bg-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5">
        <p className="eyebrow text-brass-deep">The quote process</p>
        <h2 className="mt-5 max-w-2xl font-display text-[clamp(2.2rem,5vw,4rem)] leading-[0.96] font-bold text-ink">
          <MaskedHeadline lines={["From your idea", "to a finished piece."]} />
        </h2>

        <div className="relative mt-20">
          <div className="absolute top-6 right-0 left-0 hidden h-px bg-ink/10 lg:block" />
          <div
            aria-hidden
            className="absolute top-6 right-0 left-0 hidden h-px bg-brass lg:block"
          />

          <ol className="grid gap-12 lg:grid-cols-4 lg:gap-8">
            {STEPS.map((s, i) => (
              <Reveal as="li" key={s.title} delay={i * 0.1}>
                <div className="relative lg:pr-6">
                  <span className="relative z-10 inline-flex size-12 items-center justify-center rounded-full border border-ink/15 bg-ivory font-display text-lg font-bold text-ink">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-6 font-display text-xl leading-tight font-semibold text-ink">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    {s.copy}
                  </p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>

        <Reveal delay={0.2}>
          <div className="mt-16 inline-flex items-center gap-3 border border-brass/40 bg-softwhite px-5 py-3.5">
            <Clock3 className="size-4 text-brass" aria-hidden />
            <p className="text-sm font-medium text-ink">
              Most inquiries receive a personal response within one business hour.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
